import axios from 'axios';

const API_BASE_URL = 'https://koaapi.zinvos.com';

// Create axios instance with credentials
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('member_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('member_refresh_token');
      if (refreshToken) {
        try {
          // Try to refresh the token
          const response = await axios.post(`${API_BASE_URL}/api/auth/token/refresh/`, {
            refresh: refreshToken,
          });
          
          const { access } = response.data;
          localStorage.setItem('member_access_token', access);
          
          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${access}`;
          return api(originalRequest);
        } catch (refreshError) {
          // Refresh failed, clear tokens and redirect to login
          localStorage.removeItem('member_access_token');
          localStorage.removeItem('member_refresh_token');
          window.location.href = '/';
          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);

export const memberAPI = {
  requestOTP: async (koalmNumber) => {
    const response = await api.post('/api/member/request-otp/', { 
      KOALM_number: koalmNumber 
    });
    return response.data;
  },
  
  verifyOTP: async (koalmNumber, otp) => {
    const response = await api.post('/api/member/verify-otp/', { 
      KOALM_number: koalmNumber,
      otp: otp
    });
    
    // Store tokens if present
    if (response.data.tokens) {
      localStorage.setItem('member_access_token', response.data.tokens.access);
      localStorage.setItem('member_refresh_token', response.data.tokens.refresh);
    }
    
    return response.data;
  },
  
  getProfile: async () => {
    const response = await api.get('/api/member/profile/');
    return response.data;
  },
  
  updateProfile: async (data) => {
    const response = await api.put('/api/member/profile/update/', data);
    return response.data;
  },
  
  logout: async () => {
    try {
      const response = await api.post('/api/member/logout/');
      return response.data;
    } finally {
      // Clear tokens regardless of API response
      localStorage.removeItem('member_access_token');
      localStorage.removeItem('member_refresh_token');
    }
  },
  
  downloadBadge: async () => {
    const response = await api.get('/api/member/badge/download/', {
      responseType: 'blob',
    });
    return response;
  },
};

export default api;

